"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiAlertTitle = void 0;
var global_1 = require("../../global");
var breakpoints_1 = require("../../global/breakpoints");
exports.MuiAlertTitle = {
    styleOverrides: {
        root: __assign(__assign({}, global_1.typography.regular14), (_a = { fontWeight: global_1.fontWeight.bold, margin: 0 }, _a["@media (min-width: " + breakpoints_1.breakpoints.values.sm + "px)"] = __assign(__assign({}, global_1.typography.regular14), { margin: 0, fontWeight: global_1.fontWeight.bold }), _a)),
    },
};
//# sourceMappingURL=alert-title.js.map